<template>
  <div
    v-if="richText"
    :class="$style.root"
  >
    <CoreTextComponent :string="richText" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
    richText: string
  }>()
</script>

<style module>
.root {
  composes: font-size-default from global;
}
</style>
